export const configuracionSistemaNormalize = (source) => {
    return {
        idConfiguracion: source.idConfiguracion ?? source.IdConfiguracion ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        descripcion: source.descripcion ?? source.Descripcion ?? '',
        valor: source.valor ?? source.Valor ?? '',
        activo: source.activo ?? source.Activo ?? false
    }
}
